import HelpCenter from './HelpCenter.jsx';

export default HelpCenter;